// eslint-disable-next-line import/prefer-default-export
export const REQUEST_COVERAGE_CATALOG =
  'Catalog/products/coverages?Code&userId&profileId/REQUEST_COVERAGE_CATALOG';
